import {Box, Button, Modal, Typography} from "@mui/material";
import {UserInfo} from "../services/common";
import {ApplicationItem, approveAppMigration} from "../services/applicationsApi";
import './AppDetails.css';
import React from "react";
import {useMsal} from "@azure/msal-react";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import ErrorIcon from '@mui/icons-material/Error';
import HtmlTooltip from "./HtmlTooltip.tsx";

export function isBlocked(input?: string): boolean {
    if (input == null) {
        return false;
    } else
    {
        return input?.toLowerCase().includes("blocked");
    }
}
interface AppDetailsTemporaryPrerequisitesProps {
    model: ApplicationItem | null;
    isViewMode: boolean;
    userInfo: UserInfo | null;
    handleElementUpdate: (updatedApp: ApplicationItem, closeModals: boolean) => Promise<void>;
}

const AppDetailsTemporaryPrerequisites = ({ model, isViewMode, userInfo, handleElementUpdate }: AppDetailsTemporaryPrerequisitesProps) => {
    const { instance } = useMsal();
    const [updatedApp, setUpdatedApp] = React.useState<ApplicationItem>();
    const slotProps = { inputLabel: { shrink: true } };
    const [isInfoModalVisible, setIsInfoModalVisible] = React.useState<boolean>(false);
    const onSaveClick = async () => {
        const updatedApp = await approveAppMigration(instance, model.appInstanceId);
        setUpdatedApp(updatedApp);
        await setIsInfoModalVisible(true);
    };
    const handleInfoClose = async () => {
        setIsInfoModalVisible(false);
        await handleElementUpdate(updatedApp, true);
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '840px',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };
   
    const isConfirmationEnabled = (): boolean => {
        return isViewMode && model?.isGum !== true &&
            model?.isLdap !== true &&
            model?.isArrStatusValid === true && model?.isForgerockStatusValid === true &&
            model?.hasEntraAdminAccount === true && model?.status === "Awaiting Initiation"
            && isBlocked(model?.entraIdProjectStatus) !== true &&
            (userInfo.email === model.owner || userInfo.email === model.appDelegate2 || userInfo.email === model.appDelegate1 || userInfo.email === model.primaryOwnerEmail || userInfo.email === model.secondaryOwnerEmail || userInfo.email === model.itApplicationOwnerEmail);
    };
    return (
        <div style={{ display: 'flex' }}>

            <div style={{ width: '50%' }}>
                {model?.ownerApprovalDate != null ? <Typography className="details-apps-subtitle" style={{ color: 'darkgreen', width: '310px', float: 'left', margin: '15px', height: '50px', alignContent: 'center' }}>Approved for migration</Typography>
                    : <Button style={{ margin: '15px', float: 'left', width: '310px', height: '50px', backgroundColor: '#FD5107', textTransform: 'none' }} variant="contained" color="success" onClick={onSaveClick} disabled={isConfirmationEnabled() === false}>Initiate migration</Button>
            }
            {model?.ownerApprovalDate != null
                ? <HtmlTooltip title="Migration requirement is met"><TaskAltIcon htmlColor="green" className="details-check-icon" /></HtmlTooltip>
                : <HtmlTooltip title="Migration not initiated"><ErrorIcon htmlColor="red" className="details-check-icon" /></HtmlTooltip>
            }
            </div>


            <Modal
                open={isInfoModalVisible}
                onClose={handleInfoClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={modalStyle}>
                    The migration of your SSO object from PwC Identity to IDaaS (Entra ID) has been initiated.<br/>Please check the status of your application in the portal after 10 minutes so you can collect the federation metadata.<br /><br />
                    <Button style={{ margin: '20px', float: 'right', width: '100px' }} variant="contained" color="info" onClick={handleInfoClose}>Close</Button>
                </Box>
            </Modal>
        </div>);
};
export default AppDetailsTemporaryPrerequisites;